import React, { useEffect, useState } from "react";
import "./styles.scss";

// import { ReactComponent as Center } from "../../../assets/icons/center.svg";
import { ReactComponent as StandIcon } from "../../../assets/icons/standing.svg";
import { ReactComponent as FallingIcon } from "../../../assets/icons/falling.svg";

import { ReactComponent as LowRiskImage } from "../../../assets/icons/IRAP speedometer/without icons/img_lr.svg";
import { ReactComponent as ModerateRiskImage } from "../../../assets/icons/IRAP speedometer/without icons/img_mr.svg";
import { ReactComponent as HighRiskImage } from "../../../assets/icons/IRAP speedometer/without icons/img_hr.svg";
import { ReactComponent as VeryHighRiskImage } from "../../../assets/icons/IRAP speedometer/without icons/img_vhr.svg";

import styled from "styled-components";

const MeterGaugeComponent = styled.div`
  background: ${(props) => props.color};
`;

// const CenterComponent = styled.div`
//   background: ${(props) => props.color};
// `;

// const BottomComponent = styled.div`
//   &::after {
//     background: ${(props) => props.color};
//   }

//   &::before {
//     background: ${(props) => props.color};
//   }
// `;

// const HiddenComponent = styled.div`
//   &::after {
//     border-bottom: ${(props) => props.color};
//   }

//   &::before {
//     border-bottom: ${(props) => props.color};
//   }
// `;

const Meter = (props) => {
  const {
    title,
    risk_level,
    total_points,
    risk_ranges,
    isVisible,
    scrollToNextSection,
  } = props;
  const low = parseInt(risk_ranges?.[0]?.to);
  const moderate = parseInt(risk_ranges?.[1]?.to);
  const high = parseInt(risk_ranges?.[2]?.to);
  const veryHigh = parseInt(risk_ranges?.[3]?.to);
  // const [colorCircleList, setColorCircleList] = useState([]);
  const [imageLocation, setImageLocation] = useState(null);

  const handleConrastColor = () => {
    // veryHighContrast: "#D80027",
    // highContrast: "#F48401",
    // moderateContrast: "#E8D313",
    // lowContrast: "#2DB217",
    return low >= risk_level?.score
      ? "#2DB217"
      : moderate >= risk_level?.score
      ? "#E8D313"
      : high >= risk_level?.score
      ? "#F48401"
      : veryHigh >= risk_level?.score
      ? "#D80027"
      : "";
  };
  const handleOpacityColor = () => {
    // veryHighOpacity: "#FFDEDE",
    // highOpacity: "#FED9AD",
    // moderateOpacity: "#FEF6B2",
    // lowOpacity: "#CEFFC6",
    return low >= risk_level?.score
      ? "#CEFFC6"
      : moderate >= risk_level?.score
      ? "#FEF6B2"
      : high >= risk_level?.score
      ? "#FED9AD"
      : veryHigh >= risk_level?.score
      ? "#FFDEDE"
      : "";
  };

  // const values = ((risk_level?.score ?? 0) / (total_points ?? 1)) * 200 + 178;

  // useEffect(() => {
  //   if (risk_ranges?.length) {
  //     let array = [];
  //     risk_ranges.forEach((item) => {
  //       let value = (parseInt(item?.from) / total_points) * 50;
  //       array.push(value);
  //     });
  //     array?.length && setColorCircleList(array);
  //   }
  // }, [risk_ranges, total_points]);

  useEffect(() => {
    if (risk_level && risk_ranges?.length) {
      function findRangeAndIndexForScore(score, risk_ranges) {
        const numericScore = Number(score);
        // Find the range and index that contains the score
        const result = risk_ranges.reduce(
          (acc, { from, to }, index) => {
            let numericFrom = Number(from);
            let numericTo = Number(to);

            // Ensure numericFrom is less than or equal to numericTo
            if (numericFrom > numericTo) {
              [numericFrom, numericTo] = [numericTo, numericFrom];
            }

            // Check if the score is within the current range
            if (numericScore >= numericFrom && numericScore <= numericTo) {
              acc.range = { from, to };
              acc.index = index;
            }

            return acc;
          },
          { range: null, index: null } // Initialize both range and index properties
        );
        return result;
      }

      const score = risk_level?.score;
      const { range, index } = findRangeAndIndexForScore(score, risk_ranges);

      setImageLocation(
        index === 0 ? (
          <LowRiskImage />
        ) : index === 1 ? (
          <ModerateRiskImage />
        ) : index === 2 ? (
          <HighRiskImage />
        ) : (
          <VeryHighRiskImage />
        )
      );
    }
  }, [risk_ranges, risk_level]);

  return (
    <>
      {risk_level && Object.keys(risk_level)?.length !== 0 ? (
        <MeterGaugeComponent
          className="metergauge-container"
          color={handleOpacityColor()}
        >
          <div className="fall-score">
            <h3>{title}</h3>
            <div style={{ background: handleConrastColor() }}>
              <span>{risk_level?.score}</span>
              <p>{risk_level?.risk_level}</p>
            </div>
          </div>

          <div className="meter-image">{imageLocation}</div>
          {/* <div className="container">
            <HiddenComponent
              className="hidden-bg"
              color={`86.6px solid ${handleOpacityColor()}`}
            ></HiddenComponent>
            <div className="arrow-container">
              <div
                className="arrow-wrapper"
                style={{
                  transform: `rotate(${values}deg)`,
                }}
              >
                <Center className="arrow" />
              </div>
            </div>
            <div className="containers">
              <div
                className="semi-circle"
                style={{
                  transform: `rotate(${values - 201}deg)`,
                  clipPath: `polygon(50% 0%, 100% 0, 100% 100%, 100% ${
                    ((risk_level?.score ?? 0) / (total_points ?? 1)) * 100 < 50
                      ? "86%"
                      : "44%"
                  }, 0%  ${
                    ((risk_level?.score ?? 0) / (total_points ?? 1)) * 100 < 50
                      ? "37%"
                      : "39%"
                  }, 0 65%, 0 0)`,
                }}
              >
                <div className="inner">
                  <div
                    className="clip"
                    style={{ background: handleOpacityColor() }}
                  ></div>
                </div>
                <BottomComponent
                  className="speedometer-bottom-hide"
                  color={handleOpacityColor()}
                />
              </div>
            </div>
            <div className="speedometer-container">
              <div className="center-point"></div>
              <CenterComponent className="speedometer-center-hide">
                <div className="inner">
                  <div
                    className="clip"
                    style={{ background: handleOpacityColor() }}
                  ></div>
                </div>
              </CenterComponent>
              <BottomComponent
                className="speedometer-bottom-hide"
                color={handleOpacityColor()}
              />
              <div
                className="speedometer-scale speedometer-scale-1 active"
                style={{
                  background: `conic-gradient(#2db217, #2db217 ${colorCircleList?.[0]}%, #e89518 ${colorCircleList?.[1]}%, #f06b11 ${colorCircleList?.[2]}%, red ${colorCircleList?.[3]}%, red 360%)`,
                }}
              ></div>
            </div>
          </div> */}
          <div className="icons">
            <StandIcon />
            <FallingIcon />
          </div>
          <div className="risk-analysis-container">
            <p>
              You are currently at <br />
              a&nbsp;<span>{risk_level?.risk_level}</span>&nbsp;of falling.
            </p>
          </div>
          <div className="scroll-to-top" title="Scroll to solutions">
            {isVisible && (
              <div onClick={scrollToNextSection}>Click to scroll</div>
            )}
          </div>
        </MeterGaugeComponent>
      ) : (
        ""
      )}
    </>
  );
};

export default Meter;
